"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectAlreadyInActiveTierError = {
    type: "structure",
    required: [],
    members: {},
    exceptionType: "ObjectAlreadyInActiveTierError"
};
//# sourceMappingURL=ObjectAlreadyInActiveTierError.js.map